import { CSSProperties } from "react";
import { useParams } from "react-router";
import AppHeader from "../../component/modules/appHeader/AppHeader";
import Footer from "../../component/modules/footer/Footer";
import OurDevelopmentProcessSection from "../../component/modules/ourDevelopmentProcessSection/OurDevelopmentProcessSection";
import PortfolioSection from "../../component/modules/portfolioSection/PortfolioSection";
import ServiceDetailExpertiseSection from "../../component/modules/serviceDetailExpertiseSection/ServiceDetailExpertiseSection";
import ServiceDetailFeatureSection from "../../component/modules/serviceDetailFeatureSection/ServiceDetailFeatureSection";
import ServiceDetailHighlightBlockSection from "../../component/modules/serviceDetailHighlightBlockSection/ServiceDetailHighlightBlockSection";
import TechnologyWeUseSection from "../../component/modules/technologyWeUseSection/TechnologyWeUseSection";
import HeroSection from "../../component/modules/heroSection/HeroSection";
import TechFooter from "../../component/modules/techFooter/TechFooter";
import TechMultiplePlatformSection from "../../component/modules/techMultiplePlatformSection/TechMultiplePlatformSection";
import { ServiceType } from "../../utility/types/generaTypes";
import { SERVICE_DEATIL_PAGE } from "../../utility/utilityData";
import "./index.css";

const ServiceDetail = () => {
  const { service } = useParams<{ service?: ServiceType }>();
  const currentService: ServiceType = service ?? "web_development";
  let currentServicePage = SERVICE_DEATIL_PAGE[currentService];

  return (
    <div className="servicesDeatil_page_container">
      <AppHeader />
      <div className="servicesDetail_content_container">
        <HeroSection
          isDetailPage
          sectionTitle={currentServicePage?.homeSection?.sectionHeader}
          headingpart1={currentServicePage?.homeSection?.headingPart1}
          headingpart2={currentServicePage?.homeSection?.headingPart2}
          description={currentServicePage?.homeSection?.description}
          rightComponent={
            <div
              className={`serviceSection_right_container ${
                currentService === "mobile_app_developemnt"
                  ? "serviceSection_right_container_flexDiractionRow"
                  : "serviceSection_right_container_flexDiractionCol"
              }`}
            >
              {currentServicePage?.homeSection?.serviceAdvantage.map(
                (adv, index) => (
                  <ServiceAdvantage
                    key={"ServiceAdvantage" + currentService + index}
                    title={adv?.title}
                    icon={
                      currentService === "web_development" ||
                      currentService === "mobile_app_developemnt"
                        ? adv?.icon
                        : ""
                    }
                    style={{
                      flexDirection:
                        currentService === "mobile_app_developemnt"
                          ? "column"
                          : "row",
                    }}
                  />
                )
              )}
            </div>
          }
        />
        {currentServicePage.techMultiplePlatform && (
          <TechMultiplePlatformSection
            TechMultiplePlatformData={currentServicePage.techMultiplePlatform}
            style={{ backgroundColor: "#fbfafa" }}
          />
        )}
        <PortfolioSection
          isOtherPage
          headingPart1={currentServicePage.portfolioSection.headingPart1 || ""}
          description={currentServicePage.portfolioSection.description || ""}
          portfolio={currentServicePage.portfolioSection.portfolio}
          style={{
            backgroundColor:
              currentService === "mobile_app_developemnt"
                ? "transparent"
                : "#fbfafa",
          }}
        />
        {currentServicePage?.feature && (
          <ServiceDetailFeatureSection
            featureSection={currentServicePage.feature}
            style={{
              backgroundColor:
                currentService === "mobile_app_developemnt"
                  ? "#fbfafa"
                  : "transparent",
            }}
          />
        )}
        {currentServicePage?.technologyWeUseSection && (
          <TechnologyWeUseSection
            technologyWeUseSection={currentServicePage?.technologyWeUseSection}
            style={{
              backgroundColor:
                currentService === "ui_ux" ? "#fbfafa" : "transparent",
            }}
          />
        )}
        <OurDevelopmentProcessSection
          ourDevelopmentProcessSection={
            currentServicePage.ourDevelopmentProcess
          }
          style={{
            backgroundColor:
              currentService === "web_development" ||
              currentService === "digital_marketing"
                ? "#fbfafa"
                : "transparent",
          }}
        />
        {currentServicePage.highlightBlock && (
          <ServiceDetailHighlightBlockSection
            highlightBlockSection={currentServicePage.highlightBlock}
            style={{
              backgroundColor:
                currentService === "ui_ux" ? "#fbfafa" : "transparent",
            }}
          />
        )}
        {currentServicePage?.expertise && (
          <ServiceDetailExpertiseSection
            expertiseSection={currentServicePage.expertise}
            style={{
              backgroundColor: "#fbfafa",
            }}
          />
        )}
        <TechFooter
          footerData={currentServicePage.callToActionSection}
          isThemeChange
          style={{
            background:
              currentService === "mobile_app_developemnt" ? "#fbfafa" : "white",
          }}
        />
      </div>
      <Footer />
    </div>
  );
};

type ServiceAdvantageProps = {
  title: string;
  icon?: string;
  style?: CSSProperties;
};

const ServiceAdvantage = ({ title, icon, style }: ServiceAdvantageProps) => {
  return (
    <div className="service_advantage_container" style={style}>
      {icon ? (
        <img src={icon} alt={title} />
      ) : (
        <span className="servicePoint"></span>
      )}
      <p>{title}</p>
    </div>
  );
};

export default ServiceDetail;
